import { useEffect } from 'react';
import dayjs from 'dayjs';
import { Typography } from '@mui/material';
import { Customer, LoyaltyData } from 'models';
import { useHistory } from 'react-router-dom';
import { pushAnalyticsEvent } from 'helpers/analytics';
import { ROUTES } from 'constants/routes';
import Detail from './Detail';
import DetailLink from './DetailLink';
import { Wrapper } from './UserDetailsCard.styles';

interface UserDetailsCardProps {
  loyaltyData: LoyaltyData;
  userData: Customer;
}

const UserDetailsCard = ({ loyaltyData, userData }: UserDetailsCardProps) => {
  const {
    personalDetails: { memberId },
  } = userData;
  const { memberSince, totalVouchersPurchased, totalZsEarned } = loyaltyData;
  const formattedDate = dayjs(memberSince).format('DD-MM-YYYY');
  const history = useHistory();

  useEffect(() => {
    if (window.hj) {
      window.hj('identify', memberId, { 'Total Zs Earned': totalZsEarned });
    }
  }, [memberId, totalZsEarned]);

  const handleOnClick = () => {
    pushAnalyticsEvent({ event: 'ZsActivity', location: 'User Details' });
    history.push(ROUTES.ZS_ACTIVITY);
  };

  return (
    <Wrapper>
      <Typography variant="h2">About you</Typography>
      <Detail label="Member since:" value={formattedDate} />
      <Detail label="Total Zs earned:" value={totalZsEarned} showCoin />
      <DetailLink label="View Zs Activity History" onClick={handleOnClick} />
      <Detail label="Total Perkz purchased:" value={totalVouchersPurchased} />
    </Wrapper>
  );
};

export default UserDetailsCard;
